import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { StorageService } from '../service/storage.service';

/**
 * Protege el árbol de rutas "/principal" de forma centralizada.
 * Antes cada componente repetía a mano la verificación de
 * `storageService.getUsuarioStorage()` en su ngOnInit — bastaba con
 * olvidarla en un componente nuevo para dejarlo accesible sin login.
 * Se aplica una sola vez en app-routing.module.ts sobre la ruta padre
 * 'principal', así cubre a todos sus hijos automáticamente.
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private storageService: StorageService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const usuarioStorage = this.storageService.getUsuarioStorage();

    if (usuarioStorage && Object.keys(usuarioStorage).length > 0) {
      return true;
    }

    return this.router.createUrlTree(['/login']);
  }
}
